import { d as o, _ as t } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as s, createElementBlock as r, normalizeClass as n, normalizeStyle as l, createElementVNode as a } from "vue";
const c = o("arrow-up"), p = /* @__PURE__ */ a("path", {
  d: "M1489.611 733.18a92.288 92.288 0 1 0 97.021-157.036c-145.758-90.073-291.516-179.945-437.375-270.068a138.558 138.558 0 0 0-145.506 0C858.094 396.199 712.336 486.07 566.578 576.144a92.288 92.288 0 1 0 97.02 157.036l413.007-255.064 413.057 255.064",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), i = [
  p
];
function m(e, _, d, f, u, w) {
  return s(), r("svg", {
    class: n(e.classes),
    style: l(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2252 1024",
    role: "presentation"
  }, i, 6);
}
const v = /* @__PURE__ */ t(c, [["render", m]]);
export {
  v as default
};
